import { useContext } from 'react';
import useFetch, { CachePolicies } from 'use-http';

import { AuthContext } from '@marketplace/common';

import { API_ROUTES } from '../../constants';
import type {
  TAPIFetchPartnerResponse,
  TAPIFetchPartner,
} from './fetch-partner.types';

export const useAPIFetchPartner = (id?:string): TAPIFetchPartner => {
  const { developerContext } = useContext(AuthContext);
  const partnerId = id || developerContext?.id;

  const { data, error, get, response, loading } = useFetch(
    API_ROUTES.DEVELOPERS,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const fetchPartner = async (): Promise<TAPIFetchPartnerResponse> => {
    return get(`/${partnerId}/partner`);
  };

  return {
    data: data?.data,
    error,
    loaded: response?.ok,
    loading,
    fetchPartner,
  };
};
